import { render, staticRenderFns } from "./CourierSidebar.vue?vue&type=template&id=e591f102&scoped=true"
import script from "./CourierSidebar.vue?vue&type=script&lang=js"
export * from "./CourierSidebar.vue?vue&type=script&lang=js"
import style0 from "./CourierSidebar.vue?vue&type=style&index=0&id=e591f102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e591f102",
  null
  
)

export default component.exports